import { useTenant } from '../tenant.tsx';
import { useI18n, type Lang } from '../i18n.tsx';

export function Header() {
  const tenant = useTenant();
  const { lang, setLang } = useI18n();
  const b = tenant.branding;

  return (
    <header
      style={{ background: '#111', color: '#fff', padding: '20px 0', marginBottom: 24 }}
    >
      <div
        style={{
          maxWidth: 1300,
          margin: '0 auto',
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 16,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <a
            href={b.brandUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'inline-block' }}
          >
            <img
              id="brandLogo"
              className="brand"
              src={`/image/${b.logoFile}`}
              alt={tenant.title}
              style={{ display: 'block' }}
            />
          </a>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {b.profileUrl ? (
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="iconbtn"
              title="Profil"
              href={b.profileUrl}
            >
              <i className="fa-solid fa-user" />
            </a>
          ) : null}
          {b.supportPhone ? (
            <a className="iconbtn" title="Appeler" href={`tel:${b.supportPhone}`}>
              <i className="fa-solid fa-phone" />
            </a>
          ) : null}
          {b.supportEmail ? (
            <a className="iconbtn" title="Courriel" href={`mailto:${b.supportEmail}`}>
              <i className="fa-solid fa-envelope" />
            </a>
          ) : null}
          <select
            className="lang"
            value={lang}
            onChange={(e) => setLang(e.target.value as Lang)}
            aria-label="Language"
          >
            <option value="fr">FR</option>
            <option value="en">EN</option>
          </select>
        </div>
      </div>
    </header>
  );
}
